class FeedingCalculator extends HTMLElement {
  constructor() {
    super();
    
    this.submitBtn = this.querySelector('[data-calc-amount]');
    this.resultEle = this.querySelector('[data-feeding-calc-results]');
    this.calcEle = this.querySelector('[data-feeding-calc]');
    this.resultDataEle = this.querySelector('[data-feeding-calc-results-data]');

    this.formFieldsNames = ['calculator-companion','calculator-weight','calculator-life-stage','calculator-goal'];
    this.radioButtons = this.querySelectorAll('input[name="calculator-companion"]');
    this.radioButtons.forEach(btn => btn.addEventListener('change', this.updateVisibility.bind(this)));

    this.optionGroups = this.querySelectorAll('[option-for]');

    this.rangeData = {
      dog: {
        puppy: {
          min: 4.0,
          max: 5.0
        },
        adult: {
          min: 2.0,
          max: 2.5
        },
        pregnent: {
          min: 3.5,
          max: 4.5
        },
        working: {
          min: 3.0,
          max: 4.0
        }
      },
      cat: {
        kitten: {
          min: 4.0,
          max: 5.0
        },
        adult: {
          min: 2.0,
          max: 2.5
        },
        pregnent: {
          min: 2.5,
          max: 4.5
        },
        working: {
          min: 0,
          max: 0
        }
      }
    }

    
    this.querySelector('[back-to-calc]').addEventListener('click', (e) => {
      e.preventDefault();
    
      this.classList.remove('result-visible');
      
      // Utility.slideToggle(this.calcEle,250);
      // Utility.slideToggle(this.resultEle,250);
      this.calcEle.classList.toggle('active');
      this.resultEle.classList.toggle('active');
    })
  }
  connectedCallback(){
    this.submitBtn.addEventListener('click', this.onsubmit.bind(this));
  }

  onsubmit(e) {
    e.preventDefault();
    let is_validate = this.validateInputs();
    if (!is_validate) {return false};

    this.renderData(this.prepareData());
  }
  updateVisibility(){
    this.selectedValue = this.querySelector('input[name="calculator-companion"]:checked')?.value;
    this.optionGroups.forEach(group => {
      group.style.display = group.getAttribute('option-for') === this.selectedValue ? "flex" : "none";
    });

  }
  renderData(html) {
    this.classList.add('result-visible');
    this.resultDataEle.innerHTML = html;
    if(this.resultEle.querySelector('[data-dynamic-pup]')) {
      this.flagValue= this.querySelector('input[name="calculator-companion"]:checked').value;
      if (this.querySelector('input[name="calculator-companion"]:checked').value == 'dog') {
        this.flagValue='pup';
      }
      this.resultEle.querySelector('[data-dynamic-pup]').innerHTML = this.flagValue;
    }
    

    // Utility.slideToggle(this.calcEle,250);
    // Utility.slideToggle(this.resultEle,250);

    this.calcEle.classList.toggle('active');
    this.resultEle.classList.toggle('active');
  }

  

  prepareData() {
    let getValue = (name) => this.querySelector(`input[name="${name}"]:checked`)?.value || '';
    let weight = parseInt(this.querySelector(`input[name="calculator-weight"]`)?.value || 0);
    let companion = getValue('calculator-companion');
    let lifeStage = getValue('calculator-life-stage');
    let goal = parseInt(getValue('calculator-goal') || 0);

    let { min, max } = this.rangeData[companion][lifeStage];
    let [rangeMin, rangeMax] = [min + goal, max + goal];

    let calculateRange = (factor) => [
        (rangeMin * weight * factor).toFixed(2),
        (rangeMax * weight * factor).toFixed(2),
    ];

    let [cupsMin, cupsMax] = calculateRange(2 / 100);
    let [ouncesMin, ouncesMax] = calculateRange(16 / 100);
    let [poundMin, poundMax] = calculateRange(1 / 100);

    // prepare HTMl
    let html = `
      <table>
        <thead>
          <tr>
            <th>Feeding Plan</th>
            <th>Pounds (Range)</th>
            <th>Cups (Range)</th>
            <th>Ounces (Range)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Per Day</td>
            <td>${poundMin} - ${poundMax}</td>
            <td>${cupsMin} - ${cupsMax}</td>
            <td>${ouncesMin} - ${ouncesMax}</td>
          </tr>
          <tr>
            <td>Per Week</td>
            <td>${((poundMin * 365) / 52).toFixed(2)} - ${((poundMax * 365) / 52).toFixed(2)}</td>
            <td>${((cupsMin * 365) / 52).toFixed(2)} - ${((cupsMax * 365) / 52).toFixed(2)}</td>
            <td>${((ouncesMin * 365) / 52).toFixed(2)} - ${((ouncesMax * 365) / 52).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Per Month</td>
            <td>${((poundMin * 365) / 12).toFixed(2)} - ${((poundMax * 365) / 12).toFixed(2)}</td>
            <td>${((cupsMin * 365) / 12).toFixed(2)} - ${((cupsMax * 365) / 12).toFixed(2)}</td>
            <td>${((ouncesMin * 365) / 12).toFixed(2)} - ${((ouncesMax * 365) / 12).toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    `;
    return html;
  }

  validateInputs() {
    let allValid = true;
  
    this.formFieldsNames.forEach(field => {
      const inputs = Array.from(this.querySelectorAll(`input[name="${field}"]`));
      const isValid = field === 'calculator-weight'
        ? inputs[0]?.value.trim() !== ''
        : inputs.some(input => input.checked);
  
      inputs.forEach(input => {
        const errorField = input.closest('.form-field-group')?.querySelector('[data-error-handler]');
        if (errorField) errorField.classList.toggle('d-none', isValid);
      });
  
      if (!isValid) allValid = false;
    });
  
    return allValid;
  }

}
customElements.define("feeding-calculator", FeedingCalculator);